import React from 'react';
import { Card, Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

const COLORS = {
  bgSecondary: '#161B22',
  border: '#1f2a37',
  textPrimary: '#E2E8F0',
  textSecondary: '#94A3B8',
};

const StyledCard = styled(Card)`
  background: ${COLORS.bgSecondary} !important;
  border: 1px solid ${COLORS.border} !important;
  border-radius: 0.75rem !important;
  margin-bottom: 24px;

  .ant-card-body {
    padding: 24px !important;
  }

  .ant-card-head {
    border-bottom: 1px solid ${COLORS.border} !important;
    padding: 16px 24px !important;
  }

  .ant-card-head-title {
    padding: 0 !important;
  }
`;

const ChartTitle = styled(Title)`
  color: ${COLORS.textPrimary} !important;
  font-size: 16px !important;
  margin-bottom: 0 !important;
  font-weight: 600 !important;
`;

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  extra?: React.ReactNode;
  loading?: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, children, extra, loading }) => {
  return (
    <StyledCard
      title={<ChartTitle level={5}>{title}</ChartTitle>}
      extra={extra}
      loading={loading}
    >
      {children}
    </StyledCard>
  );
};

export default ChartCard;

